import PAGES from 'constants/pages';
import { homePageLoader } from './loaders/home';
import { detailsPageLoader } from './loaders/details';
import { TVPageLoader } from './loaders/tv';
import { vodPageLoader } from './loaders/vod';
import { myWatchlistPageLoader } from './loaders/my-watchlist';
import { PagesIdType } from './types';

export const loadPageData = async (pageId: PagesIdType, { params, state }) => {
  switch (pageId) {
    case PAGES.HOME:
      return await homePageLoader(params);
    case PAGES.VOD:
      return await vodPageLoader(params);
    case PAGES.DETAILS:
      return await detailsPageLoader(params);
    case PAGES.LIVE_TV:
      return await TVPageLoader(params);
    case PAGES.MY_WATCHLIST:
      return await myWatchlistPageLoader(params);
    default:
    // nothing
  }

  return null;
};
